export enum Side {
    Home = "HOME",
    Away = "AWAY",
}
